<template>
<div class="premature-access-card">

    <div class="card-body">
        <h4 class="card-title">Hold your horses, the election hasn't started yet.</h4>
    </div>

</div>
</template>

<script>
export default {
    name: "premature-access-card",

    props: [],

    mixins: [],

    data: function () {
        return {}
    },


    computed: {},

    methods: {}

}
</script>

<style scoped>

</style>
